import type { IconProps } from './index';
import type { ReactElement } from 'react';

import { Svg } from './styles';
import { colors } from '../styles';

const ArrowLeftLineIcon = ({
  color = colors.BLACK,
  hoverColor,
  className,
}: IconProps): ReactElement => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    x="0px"
    y="0px"
    width="100%"
    height="100%"
    enableBackground="new 0 0 24 24"
    $hoverColor={hoverColor}
    className={className}
  >
    <g fill={color}>
      <path d="M15.796 18.704a1.127 1.127 0 0 1-1.594 1.594l-7.5-7.5a1.125 1.125 0 0 1 0-1.594l7.5-7.5a1.127 1.127 0 0 1 1.594 1.594L9.094 12l6.702 6.704Z" />
    </g>
  </Svg>
);

export default ArrowLeftLineIcon;
